import { render, staticRenderFns } from "./RoomsSchedulesTable.vue?vue&type=template&id=e3085660&lang=pug"
import script from "./RoomsSchedulesTable.vue?vue&type=script&lang=ts"
export * from "./RoomsSchedulesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports